<template>
  <div
    class="d-flex flex-column align-items-center w-25"
    v-if="mode == 'agent-card'"
  >
    <a href="#" @click="updateWatchList($event)">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        class="watch_list"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1673_0)">
          <rect x="0" y="0" width="48" height="48" rx="24" fill="#0f0d0d" />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M42.6391 22.6497C42.4018 22.1058 41.7605 21.8538 41.2067 22.0869C40.6529 22.3199 40.3963 22.9498 40.6336 23.4937L41.9276 26.4594C41.4862 26.3462 41.023 26.2859 40.5454 26.2859C38.0567 26.2859 35.9572 27.923 35.3025 30.1605C34.8776 30.0579 34.4404 30.0055 34 30.0055C33.5596 30.0055 33.1223 30.0579 32.6975 30.1605C32.0428 27.9229 29.9433 26.2859 27.4545 26.2859C24.4421 26.2859 22 28.6843 22 31.643C22 34.6016 24.4421 37 27.4545 37C30.2233 37 32.5103 34.9739 32.8621 32.3489C33.2254 32.2167 33.6109 32.1483 34 32.1483C34.389 32.1483 34.7745 32.2167 35.1378 32.3489C35.4897 34.9739 37.7767 37 40.5454 37C43.5579 37 46 34.6016 46 31.643L46 31.0116C45.9999 30.5764 45.9096 30.1452 45.7349 29.7452L42.6391 22.6497ZM37.2728 31.6618C37.2831 33.4283 38.7444 34.8572 40.5454 34.8572C42.3529 34.8572 43.8182 33.4181 43.8182 31.643C43.8182 29.8678 42.3529 28.4287 40.5454 28.4287C38.7439 28.4287 37.2823 29.8583 37.2728 31.6255C37.273 31.6376 37.273 31.6497 37.2728 31.6618ZM27.4545 28.4287C25.6471 28.4287 24.1818 29.8678 24.1818 31.643C24.1818 33.4181 25.6471 34.8572 27.4545 34.8572C29.2548 34.8572 30.7156 33.4296 30.7272 31.6641C30.7269 31.6504 30.7269 31.6368 30.7272 31.6231C30.7163 29.8571 29.2553 28.4287 27.4545 28.4287Z"
          fill="#454545"
          style="transform: translate(-10px, -5px);"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.7933 22.0869C27.3471 22.3199 27.6037 22.9498 27.3664 23.4937L24.2704 30.5896C24.2122 30.7227 24.182 30.8665 24.1818 31.0113V31.643C24.1818 32.2347 23.6934 32.7144 23.0909 32.7144C22.4884 32.7144 22 32.2347 22 31.643V31.0108C22.0003 30.5761 22.0905 30.1452 22.2649 29.7456L25.3609 22.6497C25.5982 22.1058 26.2395 21.8538 26.7933 22.0869Z"
          fill="#454545"
          style="transform: translate(-10px, -5px);"
        />
      </svg>
    </a>
    <div class="pt-2">{{ !watch_list_found ? "Save" : "Remove" }}</div>
  </div>
  <div v-else class="d-flex align-items-center pt-3 pb-2">
    <a href="#" @click="updateWatchList($event)" class="details-side-btn">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        class="watch_list"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1673_0)">
          <rect x="0" y="0" width="48" height="48" rx="24" fill="#1C1C1C" />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M42.6391 22.6497C42.4018 22.1058 41.7605 21.8538 41.2067 22.0869C40.6529 22.3199 40.3963 22.9498 40.6336 23.4937L41.9276 26.4594C41.4862 26.3462 41.023 26.2859 40.5454 26.2859C38.0567 26.2859 35.9572 27.923 35.3025 30.1605C34.8776 30.0579 34.4404 30.0055 34 30.0055C33.5596 30.0055 33.1223 30.0579 32.6975 30.1605C32.0428 27.9229 29.9433 26.2859 27.4545 26.2859C24.4421 26.2859 22 28.6843 22 31.643C22 34.6016 24.4421 37 27.4545 37C30.2233 37 32.5103 34.9739 32.8621 32.3489C33.2254 32.2167 33.6109 32.1483 34 32.1483C34.389 32.1483 34.7745 32.2167 35.1378 32.3489C35.4897 34.9739 37.7767 37 40.5454 37C43.5579 37 46 34.6016 46 31.643L46 31.0116C45.9999 30.5764 45.9096 30.1452 45.7349 29.7452L42.6391 22.6497ZM37.2728 31.6618C37.2831 33.4283 38.7444 34.8572 40.5454 34.8572C42.3529 34.8572 43.8182 33.4181 43.8182 31.643C43.8182 29.8678 42.3529 28.4287 40.5454 28.4287C38.7439 28.4287 37.2823 29.8583 37.2728 31.6255C37.273 31.6376 37.273 31.6497 37.2728 31.6618ZM27.4545 28.4287C25.6471 28.4287 24.1818 29.8678 24.1818 31.643C24.1818 33.4181 25.6471 34.8572 27.4545 34.8572C29.2548 34.8572 30.7156 33.4296 30.7272 31.6641C30.7269 31.6504 30.7269 31.6368 30.7272 31.6231C30.7163 29.8571 29.2553 28.4287 27.4545 28.4287Z"
          fill="#D80000"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.7933 22.0869C27.3471 22.3199 27.6037 22.9498 27.3664 23.4937L24.2704 30.5896C24.2122 30.7227 24.182 30.8665 24.1818 31.0113V31.643C24.1818 32.2347 23.6934 32.7144 23.0909 32.7144C22.4884 32.7144 22 32.2347 22 31.643V31.0108C22.0003 30.5761 22.0905 30.1452 22.2649 29.7456L25.3609 22.6497C25.5982 22.1058 26.2395 21.8538 26.7933 22.0869Z"
          fill="#D80000"
        />
      </svg>
    </a>
    <div class="details-side-chatbox">
      {{ !watch_list_found ? "Save to" : "Remove from" }} watchlist
    </div>
  </div>
</template>

<script>
export default {
  name: "watch-list-button",
  props: ["listing_type", "property", "current_user", "mode"],
  data() {
    return {
      watch_lists: [],
      watch_list_found: false,
    };
  },
  beforeMount() {
    if (this.current_user) {
      this.getWatchList();
    }
  },
  methods: {
    getWatchList: function (refetch = false) {
      if ($cookies.get("my_watch_lists") && !refetch) {
        this.watch_lists = $cookies.get("my_watch_lists");
        this.watch_list_found =
          this.watch_lists.filter(
            (watch_list) => watch_list.property_id == this.property.id
          ).length > 0;
      } else {
        let vm = this;
        this.$http
          .get(`/api/v1/user/watch_lists?scope=all`)
          .then((res) => {
            vm.watch_lists = res.data.watch_lists;
            $cookies.set("my_watch_lists", res.data.watch_lists);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    updateWatchList: function (e) {
      e.preventDefault();
      let vm = this;
      if (this.current_user) {
        const watch_list = this.watch_lists.filter(
          (watch_list) => watch_list.property_id == this.property.id
        )?.[0];
        if (watch_list) {
          this.$http
            .delete(`/api/v1/user/watch_lists/${watch_list.id}`)
            .then((res) => {
              vm.$toast.success("Property removed from watchlist successful", {
                position: "top-right",
              });
              vm.watch_list_found = false;
              vm.getWatchList("refetch");
            })
            .catch((error) => {
              vm.$toast.warning(
                "Property failed remove from watchlist.. Please try again",
                {
                  position: "top-right",
                }
              );
            });
        } else {
          this.$http
            .post("/api/v1/user/watch_lists", {
              watch_list: {
                property_id: this.property.id,
                listing_type: this.listing_type.toUpperCase(),
              },
            })
            .then((res) => {
              vm.watch_list_found = true;
              vm.getWatchList("refetch");
              vm.$toast.success("Property saved to watchlist successful", {
                position: "top-right",
              });
            })
            .catch((error) => {
              vm.$toast.warning(
                "Property failed save to watchlist.. Please try again",
                {
                  position: "top-right",
                }
              );
            });
        }
      } else {
        this.$modal.show("login-modal");
      }
    },
  },
};
</script>